<script setup lang="ts">
/** 공통 회사 헤더 — Company Name + (Incorporated in Malaysia). old_registration_no 있으면 괄호 표시. */
import { computed, inject } from 'vue';
import { TRANSFER_DOC_CTX } from '../transferContext';
import TransferDocVarField from '../TransferDocVarField.vue';

withDefaults(defineProps<{ showReg?: boolean }>(), { showReg: false });

const ctx = inject(TRANSFER_DOC_CTX)!;
const hasOldReg = computed(() => !!String(ctx.valueOf('old_registration_no') || '').trim());
</script>

<template>
  <div class="doc-head">
    <div class="doc-company"><TransferDocVarField field-key="company_name" /></div>
    <div v-if="showReg" class="doc-meta">
      [Company Registration No. <TransferDocVarField field-key="company_registration_no" /><template v-if="hasOldReg"> (<TransferDocVarField field-key="old_registration_no" />)</template>]
    </div>
    <div class="doc-meta italic">(Incorporated in Malaysia)</div>
  </div>
</template>
